module.exports = __webpack_public_path__ + "img/ic_next_single_default.d1db9257.svg";